// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_97-0";
export var optionCard = "_97-1";